<h2 mat-dialog-title>Fecha fin de servicio</h2>
<mat-dialog-content style="min-width: 400px; min-height: 100px;">
  <form [formGroup]="registerForm" (ngSubmit)="guardar()" class="example-form">
    <input type="hidden" formControlName="empresaId" value="" />

    <mat-form-field appearance="outline" class="example-full-width">
      <mat-label>Fecha</mat-label>
      <input
        formControlName="fecha"
        matInput
        placeholder="Fecha límite del servicio"
        type="date"
        [min]="minDate" [max]="maxDate"
      />
      <mat-error>La fecha es requerida</mat-error>
    </mat-form-field>

  </form>


</mat-dialog-content>
<mat-dialog-actions>
  <button
    type="submit"
    mat-button
    mat-flat-button
    color="primary"
    (click)="guardar()"
    [disabled]="registerForm.invalid"
  >
    Guardar
  </button>
  <button mat-button mat-dialog-close="false">Cancelar</button>
</mat-dialog-actions>

<!-- mat-dialog-close='false' -->
